import client from "api/client";

// F1 — categoriesApi. Website-scoped /websites/{websiteId}/content-categories.
// The WSF "News & Social" tabs are content categories. Categories support a
// hierarchy (`parent_id`) and a `sort_order`. The website comes from the path,
// so `website_id` is never sent in bodies or query params.

// Unpaginated list — used by the content form's CategorySelect.
export const listCategories = async (websiteId) => {
  const { data } = await client.get(`/websites/${websiteId}/content-categories`);
  return data.items ?? [];
};

// Paginated + searchable list — used by the Categories management screen.
export const listCategoriesPaged = async (websiteId, { limit = 25, offset = 0, search } = {}) => {
  const params = { limit, offset, sort_by: "sort_order", sort_desc: false };
  if (search) params.search = search;
  const { data } = await client.get(`/websites/${websiteId}/content-categories`, { params });
  return { items: data.items ?? [], total: data.total ?? 0, hasMore: !!data.has_more };
};

export const getCategory = async (websiteId, id) => {
  const { data } = await client.get(`/websites/${websiteId}/content-categories/${id}`);
  return data;
};

// createCategory requires name + slug; optional description, parent_id, sort_order.
export const createCategory = async (websiteId, payload) => {
  const { data } = await client.post(`/websites/${websiteId}/content-categories`, payload);
  return data;
};

export const updateCategory = async (websiteId, id, payload) => {
  const { data } = await client.put(`/websites/${websiteId}/content-categories/${id}`, payload);
  return data;
};

export const deleteCategory = async (websiteId, id) => {
  await client.delete(`/websites/${websiteId}/content-categories/${id}`);
};
